module.exports = __webpack_public_path__ + "static/img/seccess.1f72f20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/seccess.png
// module id = 3yk6
// module chunks = 21